import {
  hasTherapyRole,
  REQUEST_TYPES,
} from 'Main/contact-form/constants.ts';

/**
 * Map a counselor role to its Verified by Lavendla modal category.
 * Returns null when the role has no category-specific content, so the
 * modal falls back to the generic heading and description.
 */
export function verifiedCategoryForRole(
  role: string | null | undefined,
): string | null {
  if (hasTherapyRole(role)) {
    return REQUEST_TYPES.THERAPY;
  }

  return null;
}
